import { ListReducer, mergeEntities } from '../../store';
import { NavigationProjectFeedApiResponse } from '../project-feed/project-feed.model';
import {
  transformNavigationProjectFeedItems,
  transformNavigationProjectFeedWS,
} from './project-feed.transformers';

export const navigationProjectFeedReducer: ListReducer<
  'navigationProjectFeed'
> = (state = {}, action) => {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (
        action.payload &&
        action.payload.ref.path[0] === 'navigationProjectFeed'
      ) {
        const ref = action.payload.ref;
        const data = <NavigationProjectFeedApiResponse>action.payload.data;
        return mergeEntities<'navigationProjectFeed'>(
          state,
          transformNavigationProjectFeedItems(data),
          ref,
        );
      }
      return state;
    case 'WS_MESSAGE':
      if (action.payload.type === 'project') {
        const { data, userId } = action.payload;
        return mergeEntities<'navigationProjectFeed'>(
          state,
          transformNavigationProjectFeedWS(data),
          { path: ['navigationProjectFeed', userId] },
          'time',
        );
      }
      return state;
    default:
      return state;
  }
};

export const navigationProjectFeedFailingProjectsReducer: ListReducer<
  'navigationProjectFeedFailingProjects'
> = (state = {}, action) => {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (
        action.payload &&
        action.payload.ref.path[0] === 'navigationProjectFeedFailingProjects'
      ) {
        const ref = action.payload.ref;
        const data = <NavigationProjectFeedApiResponse>action.payload.data;
        return mergeEntities<'navigationProjectFeedFailingProjects'>(
          state,
          transformNavigationProjectFeedItems(data),
          ref,
        );
      }
      return state;
    default:
      return state;
  }
};

export const navigationProjectFeedFailingContestsReducer: ListReducer<
  'navigationProjectFeedFailingContests'
> = (state = {}, action) => {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (
        action.payload &&
        action.payload.ref.path[0] === 'navigationProjectFeedFailingContests'
      ) {
        const ref = action.payload.ref;
        const data = <NavigationProjectFeedApiResponse>action.payload.data;
        return mergeEntities<'navigationProjectFeedFailingContests'>(
          state,
          transformNavigationProjectFeedItems(data),
          ref,
        );
      }
      return state;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build/webapp/src/app/@shared/datastore/navigation/project-feed/project-feed.reducer.ts